// extracted by mini-css-extract-plugin
module.exports = {"content":"header-module--content--3iWnj","logo":"header-module--logo--U17LV"};